(ns frontend.ux-overhaul.listing.indirect-holding.event
  (:require [common.opensearch.row :as os-row]
            [common.opensearch.utils :as os-utils]
            [frontend.routing :as routing]
            [frontend.state.current-session :as session]
            [frontend.updates.entity-scope :as entity-scope]
            [re-frame.core :as rf]))

(def holding-target-alias-kw
  "The row's own :db/id is the underlying association's id, not something
   with its own entity page - clicking a row should open the real asset it
   represents instead. os-row/entity-id only knows how to read a row's OWN
   id, not an arbitrary flattened field, so this reads
   flat.indirect-holding-holding-target directly (same alias
   common.opensearch.utils/field-path->flat-alias produces for that field
   path, matching how every dedicated-index flat.* key is derived)."
  (keyword (os-utils/field-path->flat-alias [:indirect-holding/holding-target])))

(rf/reg-event-fx
 ::open-holding-target
 (fn [_ [_ value]]
   (when-let [target-id (some-> value (get holding-target-alias-kw) os-row/entity-id)]
     ;; The holding-target's own :entity/type isn't itself flattened by
     ;; deep-indexing (only the referenced entity's schema fields are), so
     ;; hydrate it into session first (the same entity-scope/fetch-once!
     ;; pattern the task port uses) and read the type back off the loaded
     ;; entity rather than guessing it.
     (entity-scope/fetch-once!
      {:entity-id target-id
       :on-done (fn [_entities]
                  (when-let [target (session/get-entity target-id)]
                    (routing/open-entity {:db/id       target-id
                                          :entity/type (:entity/type target)})))
       :on-error (fn [_error] nil)}))
   {}))
